<a href="#main-content" class="skip-link text-2xl z-5 no-underline" (click)="skipToContent($event,'main-content')">Skip to content</a>
<main class="grid min-h-screen flex-column bg-slate-200 w-12 m-auto align-items-center">
    <app-header class="col-12 p-0"></app-header>
    <div class="col-12 flex-auto p-0 max-w-custom" id="main-content" tabindex="-1">
        <ng-content></ng-content>
    </div>
    <app-cx-one-chatbot></app-cx-one-chatbot>
    <app-footer class="col-12 p-0 mt-4 max-w-custom"></app-footer>
</main>
<app-loader></app-loader>